module.exports = __webpack_public_path__ + "static/media/cred.37952c78.svg";